export default function Services() {
  return (
    <section id="services" className="px-4 py-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">事業案内</h2>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="text-center mb-6">
            <h3 className="text-lg font-bold text-primary mb-2">配線から大規模工事まで対応</h3>
            <p className="text-sm text-green-600">安全で確実な電気工事をお約束いたします</p>
          </div>
          <img 
            src="https://public.readdy.ai/ai/img_res/66ac58ea00d392618629675c23c6d33c.jpg" 
            alt="配線から大型案件まで" 
            className="w-full h-48 lg:h-64 object-cover object-top rounded-lg mb-4"
          />
          <div className="space-y-3">
            <div className="flex items-center">
              <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-full mr-3">
                <i className="ri-home-line text-white text-sm"></i>
              </div>
              <span className="text-sm font-medium text-green-700">住宅・店舗の電気工事・配線工事</span>
            </div>
            <div className="flex items-center">
              <div className="w-8 h-8 flex items-center justify-center bg-secondary rounded-full mr-3">
                <i className="ri-building-2-line text-white text-sm"></i>
              </div>
              <span className="text-sm font-medium text-green-700">工場・ビル等の電気設備工事</span>
            </div>
            <div className="flex items-center">
              <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-full mr-3">
                <i className="ri-tools-line text-white text-sm"></i>
              </div>
              <span className="text-sm font-medium text-green-700">電気設備の保守・メンテナンス</span>
            </div>
            <div className="flex items-center">
              <div className="w-8 h-8 flex items-center justify-center bg-secondary rounded-full mr-3">
                <i className="ri-flashlight-line text-white text-sm"></i>
              </div>
              <span className="text-sm font-medium text-green-700">高圧・特殊工事 弱電から強電まで対応</span>
            </div>
          </div>
        </div>
        <div className="bg-primary rounded-xl p-6 text-white">
          <h3 className="font-bold mb-3 text-green-100">SunAce の強み</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start">
              <i className="ri-shield-check-line text-yellow-300 mr-2 mt-0.5"></i>
              <span className="text-green-100">安全第一の施工体制で事故ゼロを継続</span>
            </li>
            <li className="flex items-start">
              <i className="ri-time-line text-yellow-300 mr-2 mt-0.5"></i>
              <span className="text-green-100">迅速な対応で工期短縮を実現</span>
            </li>
            <li className="flex items-start">
              <i className="ri-customer-service-2-line text-yellow-300 mr-2 mt-0.5"></i>
              <span className="text-green-100">お客様との連携を密にとりながら施工実施</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}